<template>
  <div class="stepNums" @click="gainStepData">
    <wx-open-launch-weapp id="launch-btn" username="gh_3e12937b4dbc" :path="path">
      <script type="text/wxtag-template">
  <style>.btn {color:#fff}</style>
   <span class="btn"> 获取步数授权</span>
      </script>
    </wx-open-launch-weapp>
    <!-- <span>获取步数授权</span> -->
  </div>
</template>
<script type="text/ecmascript-6">
const wx = require("weixin-js-sdk");
import QRCode from "qrcode";
import { toast, getWXInfo } from "@/common/api/api.js";
import moment from "moment";
import topPart from "../../components/topPart";

export default {
  data() {
    return {
      wxConfigData: {},
      currentBaseInfo: {},
      path: ""
    };
  },
  created() {},
  mounted() {
    this.gainStepData();
  },
  methods: {
    // 获取微信步数数据
    gainStepData() {
      this.currentBaseInfo = JSON.parse(localStorage.getItem("loginInfo"));
      let appId = localStorage.getItem("appId");
      console.log(appId,"appid");
      console.log(this.currentBaseInfo);
      this.centralControl.axios.centralControl(
        "getSignature",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            this.wxConfigData = data;
            console.log(this.wxConfigData);
            this.path = `pages/index/index.html?staffId=${this.currentBaseInfo.id}&hospitalCode=${this.currentBaseInfo.hospitalCode}&unitCode=${this.currentBaseInfo.unitCode}&userId=${this.currentBaseInfo.id}`;
            console.log(this.path);
            wx.config({
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: ["wx-open-launch-weapp"],
              openTagList: ["wx-open-launch-weapp"]
            });
            wx.ready(r => {
              console.log("ready");
            });

            // wx.error(function(res) {
            //   console.log("err", res);
            // });
          } else {
            // that.$message.error(message);
          }
        },
        { localUrl: location.href, appId }
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "personalCenter") {
      next({ name: "gainSteps" });
    } else {
      next();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/common.styl';

.stepNums {
  text-align: center;
  padding-top: 50%;
  background: #29BEBC;
  border-radius: 10px;
  display: inline-block;
  width: 130px;
  padding: 10px;
  color: #fff !important;
  margin: auto;
  position: absolute;
  top: 40%;
  left: 0;
  right: 0;
}
</style>